import React from "react";

interface Props {
  children: JSX.Element | JSX.Element[];
}

export function Card({ children }: Props) {
  return <div className={`card-base rounded-corners-large`}>{children}</div>;
}
